import envVariables from '../../consts/envVariables';
import log from '../logger/log';
import storageService from '../storageService';
import voxlinkClientService from './voxlinkClientService';

// the session is kept in localStorage, so all tabs share it, just like the gateway cookie

const getIsEnabled = () => Boolean(envVariables.VOXLINK_API_ENDPOINT);

// no refresh endpoint: once the stored session expires, the user logs in again
const getIsLoggedIn = () => {
    const session = storageService.getVoxlinkSession();

    return Boolean(session) && session.expiresAt > Date.now();
};

const createSession = async () => {
    const session = await voxlinkClientService.postAuthSession();

    storageService.setVoxlinkSession(session);
    log.info('voxlinkSessionService: Gateway session created');

    return session;
};

const endSession = async () => {
    const session = storageService.getVoxlinkSession();

    if (!session) return;

    storageService.removeVoxlinkSession();

    try {
        await voxlinkClientService.deleteAuthSession(session.sessionId);
    } catch (e) {
        // fine to ignore: the gateway expires the session on its own
        log.warn(`voxlinkSessionService: Gateway logout failed, status: ${e?.response?.status}`);
    }
};

export default {
    getIsEnabled,
    getIsLoggedIn,
    createSession,
    endSession,
};
